module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "copyright-page",
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2018 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. No part of this book may be used or reproduced in any manner whatsoever without written permission, except in the case of brief quotations in critical articles and reviews. For more information, contact the University of Chicago Press, 1427 E. 60th St., Chicago, IL 60637.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Published 2018")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("27 26 25 24 23 22 21 20 19 18    1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-59050-9 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-59064-6 (paper)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-59078-3 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("DOI")]), _vm._v(": "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://doi.org/10.7208/chicago/9780226590783.001.0001",
      "target": "_blank"
    }
  }, [_vm._v("https://doi.org/10.7208/chicago/9780226590783.001.0001")])]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Names: Fattal, Alexander L., author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Title: Guerrilla marketing : counterinsurgency and capitalism in Colombia / Alexander L. Fattal.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Other titles: Chicago studies in practices of meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Description: Chicago ; London : The University of Chicago Press, 2018. | Series: Chicago studies in practices of meaning | Includes bibliographical references and index.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Identifiers: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCCN")]), _vm._v(" 2018019138 | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226590509 (cloth : alk. paper) | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226590646 (pbk. : alk. paper) | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 9780226590783 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Subjects: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCSH")]), _vm._v(": Colombia—Politics and government—1974– | Propaganda—Colombia. | Counterinsurgency—Colombia. | Mass media and peace—Colombia. | Mass media and war—Colombia. | Insurgency—Colombia. | Fuerzas Armadas Revolucionarias de Colombia.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Classification: "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("LCC")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("F")]), _vm._v("2279 ."), _c('span', {
    staticClass: "sm"
  }, [_vm._v("F")]), _vm._v("387 2018 | "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DDC")]), _vm._v(" 986.106/34—dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("LC")]), _vm._v(" record available at "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://lccn.loc.gov/2018019138",
      "target": "_blank"
    }
  }, [_vm._v("https://lccn.loc.gov/2018019138")])]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "12",
      "src": "images/infinity-symbol.jpg",
      "width": "12"
    }
  }), _vm._v(" This paper meets the requirements of "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ANSI/NISO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("Z")]), _vm._v("39.48–1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d944c5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-fattal-0005.vue
// module id = 66
// module chunks = 0